(function () {
   'use strict';

   angular
      .module('iqxCore')
      .controller('JobSearchAppliedCtrl', JobSearchAppliedCtrl)

   function JobSearchAppliedCtrl($scope, FormSvc, SweetAlert, LanguageSvc) {
      $scope.sortedRecords = []
      $scope.jobsToShow = ""


      $scope.getAllJobs = function () {
         $scope.jobsToShow = "all"
         $scope.sortedRecords = $scope.theRecords
      }

      $scope.getCurrentJobs = function () {
         $scope.jobsToShow = "current"
         $scope.sortedRecords = []
         for (var job of $scope.theRecords) {
            if (job.StatusIsFinal === 0) {
               $scope.sortedRecords.push(job)
            }
         }
      }

      $scope.getFinishedJobs = function () {
         $scope.jobsToShow = "finished"
         $scope.sortedRecords = []
         for (var job of $scope.theRecords) {
            if (job.StatusIsFinal !== 0) {
               $scope.sortedRecords.push(job)
            }
         }
      }

      $scope.getRecords = function () {
         FormSvc.setOptions($scope, {
            fetchAPI: 'callresult/NetCandidateGetJobsAppliedFor',
            multiRow: true,
            doNotPreventNav: true,
            dateFields: ['DateApplied']
         })
         $scope.fetch().then($scope.getAllJobs)
      }



      $scope.goToJob = function (job) {
         let lang = LanguageSvc.lang.pages.jobsearch

         SweetAlert.swal({
            type: "info",
            title: lang.position + `: ${job.Position} `,
            html: lang.reference + `: ${job.RefCode} </br>` +
               lang.position + `: ${job.Position} </br>` +
               lang.department + `: ${job.Department} </br>` +
               lang.startdate + `: ${moment(job.StartDate).format('DD/MM/YYYY')} </br>` +
               `${(job.InterviewDate !== null) ? lang.InterviewDate + ':' + moment(job.InterviewDate).format('DD/MM/YYYY') + '</br>' : ''}` +
               `${(job.InterviewTime !== null) ? lang.InterviewTime + ':' + job.InterviewTime + '</br>' : ''}` +
               lang.progress + `: ${job.StatusName} </br>` +
               lang.contact + `: ${job.Staff} </br>` +
               lang.email + `: ${job.Email}`
         })
      }

      $scope.getRecords()

   }


})()